module.exports = __webpack_public_path__ + "static/media/revlon.14090d3b.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/brand-logos/revlon.png
// module id = 110
// module chunks = 0